export default __webpack_public_path__ + "static/media/section1-process-bg1.14345091.png";